import { Badge } from "@shared/components/ui/badge";
import { FileText, FileX, DollarSign, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";

const InvoiceBadge = ({ pkg }) => {
  const { t } = useTranslation();

  // If package has no invoice
  if (!pkg.invoice) {
    return (
      <Badge
        variant="outline"
        className="text-xs border-gray-300 text-gray-600 bg-gray-50 hover:bg-gray-100"
      >
        <FileX className="h-3 w-3 ltr:mr-1 rtl:ml-1" />
        {t("invoiceStatus.noInvoice")}
      </Badge>
    );
  }

  // If package has an invoice, show invoice status
  const invoiceStatus = pkg.invoice.status;

  if (invoiceStatus === "paid") {
    return (
      <Badge
        variant="outline"
        className="text-xs border-green-300 text-green-700 bg-green-50 hover:bg-green-100"
      >
        <DollarSign className="h-3 w-3 ltr:mr-1 rtl:ml-1" />
        {t("invoiceStatus.invoicePaid")}
      </Badge>
    );
  }

  if (invoiceStatus === "pending") {
    return (
      <Badge
        variant="outline"
        className="text-xs border-yellow-300 text-yellow-700 bg-yellow-50 hover:bg-yellow-100"
      >
        <Clock className="h-3 w-3 ltr:mr-1 rtl:ml-1" />
        {t("invoiceStatus.invoicePending")}
      </Badge>
    );
  }

  // Default case - invoice exists but status unknown
  return (
    <Badge
      variant="outline"
      className="text-xs border-blue-300 text-blue-700 bg-blue-50 hover:bg-blue-100"
    >
      <FileText className="h-3 w-3 ltr:mr-1 rtl:ml-1" />
      {t("invoiceStatus.invoiceExists")}
    </Badge>
  );
};

export default InvoiceBadge;
